<template>
    <div id="search-results-drawer"
        ref="drawer"
        :class="{'uk-open': openDrawer === true}">
        <div
            @touchstart="handleTouchStart"
            @touchmove="handleTouchMove"
            @click="toggleDrawer">
            <hr class="uk-margin-small-top"/>
            <div class="header">
            <slot name="header"></slot>
            </div>
        </div>
        <div class="uk-padding-small uk-padding-remove-top">
            <div ref="scrollContentRef" @scroll="handleScroll" id="drawer-content">

            <slot></slot>
        </div>
        </div>
    </div>
</template>
<script setup lang="ts">
import { ref, Ref, watch } from 'vue'
const touchStartY = ref(0)
const touchEndY = ref(0)
const openDrawer = ref(false)
const drawer: Ref<HTMLElement | null> = ref(null)
const scrollContentRef: Ref<HTMLElement | null> = ref(null);

const props = defineProps({
    close: {
        type: Boolean,
        default: false
    }
})

 watch(
     () => props.close, (closeValue) => {
        if(closeValue === true) openDrawer.value = false
    }
);

const handleScroll = () => {
  // Access the actual scroll content element dynamically
  if (!scrollContentRef.value || !drawer.value) return;
  // Extract scroll information
  const { scrollTop, scrollHeight, clientHeight } = scrollContentRef.value;

    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage > 0) {
        drawer.value.classList.add('scrolling')
    } else {
        drawer.value.classList.remove('scrolling')
  }

};
// Ensure event types to be TouchEvent
const handleTouchStart = (e: TouchEvent) => {
    touchStartY.value = e.touches[0].clientY
};
const toggleDrawer = () => {
    openDrawer.value = !openDrawer.value
}

const handleTouchMove = (e: TouchEvent) => {
    touchEndY.value = e.changedTouches[0].clientY;
    handleSwipe();
    e.preventDefault(); // prevent scrolling if touch is on the drawer
  };

const handleSwipe = () => {
    if (!drawer.value) return

    const clickEvent = new Event('click')
    if (drawer.value.classList.contains('uk-open')) {
        if (touchEndY.value > touchStartY.value) { // Swipe down
            if (drawer.value) drawer.value.dispatchEvent(clickEvent)
            openDrawer.value = false
        }
    } else {
        if (touchEndY.value < touchStartY.value) { // Swipe up
            if (drawer.value) drawer.value.dispatchEvent(clickEvent)
            openDrawer.value = true
        }
    }
}
</script>
<style scoped>
::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    border-radius: 34px;
}

/* Track */
::-webkit-scrollbar-track {
    background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
    background: #285960;
    border-radius: 8px;
    transition: all 0.4s;
    -moz-transition: all 0.4s;
    -webkit-transition: all 0.4s;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
    background: #555;
    border-radius: 16px;
}
#search-results-drawer{
    background: #FFF;
    border-top-left-radius: 32px;
    border-top-right-radius: 32px;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: 1010;
    box-shadow: 0 -10px 13px rgba(0,0,0,.1);
    transition: all 0.4s ease-in-out;
}
.uk-open.scrolling .header{
    transition: box-shadow .2s ease-in;
    border-bottom: 1px #D9D9D9 solid;
    box-shadow: 0px 4px 8px -2px rgba(16, 24, 40, 0.10);
}
#search-results-drawer.uk-open #drawer-content{
    transition: all 0.4s ease-in-out;
    /*max-height: 400px;*/
    max-height: calc(100vh - 308px);
    overflow-y: auto;
    height: calc(100vh - 308px);
}
#search-results-drawer hr{
    max-width: 52px;
    background-color: #D9D9D9;
    border-radius: 8px;
    display: block;
    height: 4px;
    margin-left: auto;
    margin-right: auto;
}
#drawer-content{
    overflow-y: hidden;
    max-height: 0;
    height: calc(100vh - 316px);
    transition: all 0.4s ease-in-out;
}
@media(min-width:680px){
    #search-results-drawer.uk-open #drawer-content{
        max-height: calc(100vh - 316px);
    }
}
</style>